module.exports = __webpack_public_path__ + "static/media/graphql.8c005987.png";